function LoadingScreen({active}){
	return(
		<div className={`loadingScreen ${active ? "active" : ""}`}>
			<img src={`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_IMAGE_PATH}/logo.png`} alt="JoyNFC Logo"/>
			<img src={`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_IMAGE_PATH}/loading.gif`} alt="Loading Gif"/>
		</div>
	)
}
export default LoadingScreen;